<template>
	<div class="flex items-center justify-center min-h-screen px-4">
		<UiMessage :image="unavailableImage" :max-width="300">
			<div class="mt-4 text-lg font-semibold">
				{{ t('appUnavailable.title') }}
			</div>
			<div class="mt-2 text-base text-gray-500">
				{{ t('appUnavailable.description') }}
			</div>
		</UiMessage>
	</div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import UiMessage from '@/components/ui/UiMessage.vue';
import unavailableImage from '@/assets/icons/fallen-ice-cream.svg';

const { t } = useI18n();
</script>
